function PricingHeader() {
  return (
    <div className="headerBox">
      <div className="pricingTextBox">
        <h1 className="pricingHeaderText">Pricing</h1>
      </div>
    </div>
  );
}
export default PricingHeader;
